module.exports = __webpack_public_path__ + "img/back-icon04.4b83e3e0.png";